import peru from './peru';

export default {
  namespaced: true,
  modules: {
    peru
  }
};
